module.exports = "./img/desktop_logo.011e2c3.png";